module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(!_vm.isAuthenticating) ? _c('v-app', {
    attrs: {
      "dark": _vm.dark
    }
  }, [_c('the-left-sidebar', {
    ref: "leftSidebar",
    attrs: {
      "dark": _vm.dark
    },
    on: {
      "update:dark": function($event) {
        _vm.dark = $event
      }
    }
  }), _vm._v(" "), _c('the-header', {
    on: {
      "toggle-drawer": function($event) {
        _vm.$refs.leftSidebar.drawer = !_vm.$refs.leftSidebar.drawer
      }
    }
  }), _vm._v(" "), _c('v-content', [_c('v-container', {
    class: {
      'pa-1': _vm.fluid
    },
    attrs: {
      "fluid": _vm.fluid
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('the-player', {
    on: {
      "toggle-drawer": function($event) {
        _vm.$refs.rightSidebar.drawer = !_vm.$refs.rightSidebar.drawer
      }
    }
  }), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 6000,
      "left": _vm.$vuetify.breakpoint.lgAndUp,
      "bottom": _vm.$vuetify.breakpoint.lgAndUp,
      "top": _vm.$vuetify.breakpoint.mdAndDown,
      "right": _vm.$vuetify.breakpoint.mdAndDown
    },
    model: {
      value: (_vm.snackbar.show),
      callback: function($$v) {
        _vm.$set(_vm.snackbar, "show", $$v)
      },
      expression: "snackbar.show"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.snackbar.text) + "\n            ")])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8399f25c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 390
// module chunks = 0